module.exports = __webpack_public_path__ + "img/wifi.d9f7ef95.png";